module.exports = __webpack_public_path__ + "img/client (4).80e709ed.jpg";